import { render, staticRenderFns } from "./AccommodationReviewForm.vue?vue&type=template&id=542b02e1&scoped=true&"
import script from "./AccommodationReviewForm.vue?vue&type=script&lang=js&"
export * from "./AccommodationReviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b02e1",
  null
  
)

export default component.exports